import React from 'react';
import DesktopMonitor from 'assets/kcc-monitor.svg';
import { useStyles } from './styled';
import { Grid, Typography as MuiTypography } from '@mui/material';

export const KioskControlCenter = () => {
  const classes = useStyles();
  return (
    <Grid container direction="column" className={classes.controlCenterContainer}>
      <div className={classes.controlImageBlock}>
        <img src={DesktopMonitor} alt="KCC Desktop" className={classes.controlCenterImage} />
      </div>
      <div className={classes.controlTextBlock}>
        <MuiTypography className={classes.controlCenterHeading} style={{ fontWeight: 600 }}>
          Kiosk Control Center
        </MuiTypography>
        <MuiTypography className={classes.controlCenterDescription}>
          Your dashboard for managing <br /> your kiosks remotely.
        </MuiTypography>
      </div>
    </Grid>
  );
};
